import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../api/axios';
import toast from 'react-hot-toast';

const Login = () => {
  var [email, setEmail] = useState('');
  var [password, setPassword] = useState('');
  var [loading, setLoading] = useState(false);
  var { login } = useAuth();
  var navigate = useNavigate();

  var [showAdminModal, setShowAdminModal] = useState(false);
  var [adminUsername, setAdminUsername] = useState('');
  var [adminPassword, setAdminPassword] = useState('');
  var [adminLoading, setAdminLoading] = useState(false);

  var handleSubmit = async function (e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (error) {
      toast.error((error.response && error.response.data && error.response.data.message) || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  var handleAdminVerify = async function (e) {
    e.preventDefault();
    if (!adminUsername || !adminPassword) { toast.error('Enter credentials'); return; }
    setAdminLoading(true);
    try {
      var res = await API.post('/admin/verify', { username: adminUsername, password: adminPassword });
      if (res.data.success) {
        toast.success('Admin verified');
        setShowAdminModal(false);
        localStorage.setItem('adminToken', res.data.data.adminToken);
        navigate('/admin', { state: { adminVerified: true } });
      }
    } catch (error) {
      toast.error((error.response && error.response.data && error.response.data.message) || 'Invalid credentials');
    } finally {
      setAdminLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #f0fdf4 0%, #ffffff 50%, #f0fdf4 100%)' }}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/logo.jpg"
            alt="Vasify"
            className="w-48 h-20 mx-auto mb-4 rounded-2xl object-contain"
            onError={(e) => {
              e.target.style.display = 'none';
              document.getElementById('fallback-logo').style.display = 'flex';
            }}
          />
          <div
            id="fallback-logo"
            className="w-16 h-16 mx-auto mb-4 rounded-2xl items-center justify-center text-white text-3xl font-bold"
            style={{ backgroundColor: '#25D366', display: 'none' }}
          >
            V
          </div>
          <h1 className="text-3xl font-bold text-gray-900">
            Vasify <span style={{ color: '#25D366' }}>CRM</span>
          </h1>
          <p className="text-gray-500 mt-2">Sign in to your account</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" placeholder="company@example.com" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" placeholder="••••••••" required />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full py-2.5">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="mt-6 pt-4 border-t border-gray-100 text-center">
            <button onClick={() => setShowAdminModal(true)} className="text-xs text-gray-400 hover:text-gray-600 transition-colors">
              🔐 Admin Access
            </button>
          </div>
        </div>
      </div>

      {/* Admin Modal */}
      {showAdminModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={() => { setShowAdminModal(false); setAdminUsername(''); setAdminPassword(''); }}></div>
          <div className="relative bg-white rounded-xl shadow-xl w-full max-w-sm">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">🔐 Admin</h2>
              <button onClick={() => { setShowAdminModal(false); setAdminUsername(''); setAdminPassword(''); }} className="text-gray-400 hover:text-gray-600 text-xl">✕</button>
            </div>
            <div className="px-6 py-4">
              <form onSubmit={handleAdminVerify} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
                  <input type="text" value={adminUsername} onChange={(e) => setAdminUsername(e.target.value)} className="input-field" placeholder="Admin username" required autoComplete="off" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                  <input type="password" value={adminPassword} onChange={(e) => setAdminPassword(e.target.value)} className="input-field" placeholder="Admin password" required autoComplete="off" />
                </div>
                <div className="flex gap-3 pt-2">
                  <button type="button" onClick={() => { setShowAdminModal(false); setAdminUsername(''); setAdminPassword(''); }} className="btn-secondary flex-1 text-sm">Cancel</button>
                  <button type="submit" disabled={adminLoading} className="btn-primary flex-1 text-sm">{adminLoading ? 'Verifying...' : 'Verify'}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;